export const isCsvFile = file => {
  const { files } = file;
  const { name, type } = files[0];
  const extRegEx = new RegExp('.*\.[cC][sS][vV]$'); // eslint-disable-line
  const isCorrectExtension = extRegEx.test(name);
  const isCsv =
    (type === 'text/csv' || type === 'application/vnd.ms-excel' || type === '') &&
    isCorrectExtension; // because, IE 😡
  return isCsv;
};

export const heresSomeNullForYou = () => null;



// WEBPACK FOOTER //
// ./src/constants/utils.js